import { createContext, useContext, useEffect, useState } from 'react';
import {
  getNetworkState,
  initNetworkConnectivity,
  subscribeNetwork,
} from './connectivity';
import ConnectivityBanner from '@/components/network/ConnectivityBanner';

const NetworkContext = createContext(getNetworkState());

export function NetworkProvider({ children }) {
  const [network, setNetwork] = useState(getNetworkState());

  useEffect(() => {
    let unsub = () => {};
    initNetworkConnectivity().then((initial) => {
      setNetwork(initial);
      unsub = subscribeNetwork(setNetwork);
    });
    return () => unsub();
  }, []);

  return (
    <NetworkContext.Provider value={network}>
      <ConnectivityBanner />
      {children}
    </NetworkContext.Provider>
  );
}

export function useNetwork() {
  return useContext(NetworkContext);
}
